var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#EBFBF1","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8C20.4183 8 24 11.5817 24 16ZM18.5605 13.2648C18.7558 13.0695 19.0724 13.0695 19.2676 13.2648L19.8176 13.8147C20.0128 14.01 20.0128 14.3266 19.8176 14.5219L15.4964 18.8431C15.398 18.9415 15.2687 18.9903 15.1397 18.9895C15.0127 18.9888 14.8859 18.94 14.789 18.8431L12.3534 16.4075C12.1582 16.2122 12.1582 15.8956 12.3534 15.7004L12.9034 15.1504C13.0987 14.9551 13.4153 14.9551 13.6105 15.1504L15.1427 16.6826L18.5605 13.2648Z","fill":"#00C853","key":1})]);
}

Checkmark.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
